import apiConfig from '@constants/apiConfig';

import RestaurantExpiredListPage from '.';

export default {
    restauranExpiredtListPage: {
        path: '/restaurants-expired',
        title: 'Restaurants-Expired',
        auth: true,
        component: RestaurantExpiredListPage,
        permission: [ apiConfig.restaurant.getList.baseURL ],
    },
};
